


































import { Component, Inject, Vue } from "vue-property-decorator";
import { AttivitaService } from "@/data/services/attivita.service";
import AttivitaTable from "@/packages/eventi-list/AttivitaTable.vue";
import AttivitaList from "@/packages/eventi-list/AttivitaList.vue";
// @ts-ignore
import "vue-cal/dist/i18n/it.js";
import "vue-cal/dist/vuecal.css";

import { Page } from "yellowfin-ui-lib";
import {
  Attivita,
  AttivitaRequest,
  DATE_FROM_NULL,
  DATE_TO_NULL,
} from "@/data/models/attivita.model";
import AttivitaSearch from "@/packages/eventi-list/AttivitaSearch.vue";
import packageInfo from "../../../package.json";
@Component({
  components: {
    AttivitaTable,
    AttivitaSearch,
    AttivitaList,
  },
})
export default class EventiList extends Vue {
  @Inject("AttivitaService") attivitaService!: AttivitaService;

  eventUrl: string = process.env.VUE_APP_EVENT_URL as string;
  view: string | null = "table";

  start!: number;
  end!: number;

  now: Date = new Date();

  data: Attivita[] = [];
  loading = false;

  searchparam!: AttivitaRequest;
  page: Page = new Page(20);

  all: "all" | "current" | "future" | undefined = "current";

  ready: boolean = false;

  search() {
    this.loading = true;
    const searchreq = this.attivitaService.search(this.searchparam, this.page);
    const countreq = this.attivitaService.searchCount(this.searchparam);
    Promise.all([searchreq, countreq])
      .then((results) => {
        this.data = results[0];
        this.page.setTotal(results[1].cnt);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  onSearchChange(searchparam: AttivitaRequest) {
    this.searchparam = searchparam;
    this.search();
  }

  onPageChange(page: number) {
    this.page.setPageNumber(page - 1);
    this.search();
  }

  mounted() {
    const dataall = this.$el.parentElement?.getAttribute("data-all");

    if (dataall === "true" || dataall === "all") {
      this.all = "all";
    } else if (dataall === "future") {
      this.all = "future";
    }
    if (
      this.$el.parentElement?.getAttribute("data-view") !== undefined &&
      this.$el.parentElement?.getAttribute("data-view") !== null
    ) {
      this.view = this.$el.parentElement?.getAttribute("data-view");
      //      this.all = true;
    }
    this.ready = true;

    console.log("this.all", this.all);
    this.searchparam = new AttivitaRequest();
    /* commento questo pezzo che mi pare non usi

 const now = new Date();
   
    this.start = new Date(
      now.getFullYear(),
      now.getMonth(),
      1,
      0,
      0,
      0,
      0
    ).getTime();
    this.end = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      1,
      23,
      59,
      0,
      0
    ).getTime();

    

    this.searchparam.iniziodal =
      this.all === "all" ? DATE_FROM_NULL : Math.round(this.start / 1000);
    this.searchparam.inizioal =
      this.all !== "current" ? DATE_TO_NULL : Math.round(this.end / 1000);

    console.log(this.searchparam, DATE_FROM_NULL, DATE_TO_NULL);
    */
    // this.onSearchChange(this.searchparam);
  }

  beforeMount() {
    console.log(`UI v. ${packageInfo.version}`);
  }
}
